import * as actionTypes from '../actions/actionTypes'

const initialState = {
    loading: false,
    isPromotional: true,
    brandAuthConfig: process.env.REACT_APP_BRAND_AUTH_CONFIG ?
        (typeof process.env.REACT_APP_BRAND_AUTH_CONFIG === 'string' ? JSON.parse(process.env.REACT_APP_BRAND_AUTH_CONFIG) : process.env.REACT_APP_BRAND_AUTH_CONFIG) : {}
};
// console.log('initial state.....', JSON.stringify(initialState));
const setLoading = (state, action) => {
    return {
        ...state,
        loading: action.data.loading,
        isPromotional: action.data.isPromotional && action.data.isPromotional
    }
}

const loadBrandAuthConfig = (state) => {
    return {
        ...state,
        brandAuthConfig: process.env.REACT_APP_BRAND_AUTH_CONFIG ? JSON.parse(process.env.REACT_APP_BRAND_AUTH_CONFIG) : {}
    }
}

const loadQuizDetails = (state, action) => {
    return {
        ...state,
        quizDetails: action.data
    }
}

const loadQuizTypeDetails = (state, action) => {
    return {
        ...state,
        allQuizDetails: action.data
    }
}

const commonReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_LOADING: return setLoading(state, action);
        case actionTypes.LOAD_BRAND_AUTH_CONFIG: return loadBrandAuthConfig(state);
        case actionTypes.LOAD_QUIZ_DETAILS: return loadQuizDetails(state, action);
        case actionTypes.LOAD_QUIZ_TYPE_DETAILS: return loadQuizTypeDetails(state, action);
        default:
            return state;
    }
};


export default commonReducer;


/** WEBPACK FOOTER **
 ** ./src/store/reducer/commonReducer.js
 **/